import React from "react"
import { MediaViewProps } from "./MediaView.types"
import * as UploadUtil from "../../library/upload/UploadUtil"
import ImageView from "../ImageView/ImageView"
import { MediaQuality } from "../../library/upload/Upload"
import VideoPlayer from "../VideoPlayer/VideoPlayer"

const MediaView: React.FC<MediaViewProps> = ({
  upload,
  videoOptions,
  className,
  style,
  quality,
  imgAttributes,
  onClick,
  isReadyCallback }: MediaViewProps) => {

  const handleIsReady = (description: string) => {
    isReadyCallback && isReadyCallback(upload.code, `Upload ${upload.code} ${description} for ${className}`)
  }

  let isVideo = upload.mimeType.includes("video/")
  let posterImage = upload.media?.thumbnail

  let src = ""
  if (upload.media) {
    src = UploadUtil.selectFilePath(upload, quality ?? MediaQuality.MEDIUM) ?? src
  }
  if (videoOptions.previewOnly) src = posterImage

  if (src === "") {
    return <div onLoad={() => handleIsReady("loaded empty media")}></div>
  }

  if (isVideo && !videoOptions.previewOnly) {
    return <VideoPlayer
      src={src}
      style={style}
      className={className}
      wantsToPlay={videoOptions.play}
      aspectFit={videoOptions.aspectFit}
      initialAspectRatio={upload.dimensions.aspect}
      onClick={onClick}
      onCanPlay={() => handleIsReady("can play video")}
      onError={() => handleIsReady("video errored")}
      onAbort={() => handleIsReady("video aborted")}
      {...videoOptions.attributes}
    />
  }

  return <ImageView
    src={src}
    style={style}
    className={className}
    imgAttributes={imgAttributes}
    onClick={onClick}
    didLoad={() => handleIsReady(isVideo ? "can play video" : "loaded image")}
    didFail={() => handleIsReady("image failed")}
  />
}

export default MediaView;